"use strict";
/*
 * Created on 01 15 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../utils");

var ValidationResultFlag_1 = require("../ValidationResultFlag");

var ValidationResultObject_1 = require("../ValidationResultObject");

var ValidationResultObjectConverter_1 = require("./ValidationResultObjectConverter");
/**
 * Implementation of {@link ValidationResultObjectConverter}
 *
 * @author JMe
 * @author Radek Beran
 */


var ValidationResultObjectConverterImpl =
/*#__PURE__*/
function (_ValidationResultObje) {
  _inherits(ValidationResultObjectConverterImpl, _ValidationResultObje);

  function ValidationResultObjectConverterImpl() {
    _classCallCheck(this, ValidationResultObjectConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValidationResultObjectConverterImpl).apply(this, arguments));
  }

  _createClass(ValidationResultObjectConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        severity: source.severity,
        messageKey: source.messageKey,
        messageVariables: conversions.asObjectArray(source, 'messageVariables', function (v) {
          return v;
        }),
        userMessage: source.userMessage,
        entityId: conversions.toDocumentReferenceId(source.entityId),
        flags: source.flags.serialize()
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ValidationResultObject_1.ValidationResultObject(ValidationResultObject_1.ValidationResultObject.schema.severity.valueOfField(source), ValidationResultObject_1.ValidationResultObject.schema.messageKey.valueOfField(source), ValidationResultObject_1.ValidationResultObject.schema.messageVariables.valueOfField(source), ValidationResultObject_1.ValidationResultObject.schema.userMessage.valueOfField(source), ValidationResultObject_1.ValidationResultObject.schema.entityId.valueOf(conversions.toClassReferenceId(source.entityId)), !utils_1.Utils.isValueMissing(source.flags) ? conversions.asFlagSet(source.flags, ValidationResultFlag_1.ValidationResultFlag) : ValidationResultFlag_1.ValidationResultFlag.EMPTY_SET);
    }
  }]);

  return ValidationResultObjectConverterImpl;
}(ValidationResultObjectConverter_1.ValidationResultObjectConverter);

exports.ValidationResultObjectConverterImpl = ValidationResultObjectConverterImpl;